import { inject, Injectable } from '@angular/core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceAllAttachmentsService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getAllUploadDocuments(RepCode: string) {

    const API_URL: string = environment.baseUrl + environment.apis.getAllUploadedDocuments;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
       "pias_rep_code":RepCode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async previewdocuments(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewchecklistdocuments + `/${viewid}`;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return new Blob([httpResponse.data], {
          type: 'application/pdf'
        });
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
